<template lang="pug">
  div.map-popup.map-popup-tko
    div(v-if="loading")
      div.tooltip__head
        p.title Загрузка...
        span(@click="close($event)").close.close--small.close--tooltip
      div.tooltip__body
        div.spinner
          div.rect1
          div.rect2
          div.rect3
          div.rect4
          div.rect5

    div(v-else-if="error")
      div.tooltip__head
        p.title Ошибка
        span(@click="close($event)").close.close--small.close--tooltip

    div(v-else-if="!loading")
      div.tooltip__head
        div.tooltip__title.semibold {{head}}
        button.reset-btn(@click="close($event)").close.close--small.close--tooltip
      div.tooltip__body
        popup-fields-rows(:rows="rows" :model="fields")
        .tooltip__error(v-if="hasErrorCapacity" ) Сумма масс отходов, транспортируемых по потокам на объект обращения, превышает его мощность
        div(v-if="loadingPercent").tooltip__body-bar
          div Загрузка объекта: {{loadingPercent}}%
          div.progressbar
            div.progressbar.progressbar--loaded(:style="{'width': loadingPercent + '%'}")

      div.tooltip__footer.tooltip__foot
        button.button.reset-btn.button_no-border(v-if="showMore" @click.prevent="more") Подробнее
</template>

<script>
import { map as mapEndpoints } from '@/api/api-endpoints'
import baseMapPopupMixin from './base-map-popup-mixin'
import PopupFieldsRows from './popup-fields-rows'
import year from '@/utils/year'
import url from '@/utils/url'

/*
   active  - зеленый
   planned - желтый

   */
export default {
  name: 'map-popup-tko',
  components: { PopupFieldsRows },
  mixins: [baseMapPopupMixin],
  data() {
    this.closeCallback = null
    this.redirectParams = {}
    return {
      fields: {},
      hasErrorCapacity: false,
    }
  },
  computed: {
    loadingPercent() {
      if (this.markerModel.percentOfLoading && this.markerModel.power) {
        let percent = Math.round(this.markerModel.percentOfLoading)
        if (percent > 100) {
          percent = 100
        }
        return percent
      }
      return null
    },
  },
  methods: {
    injectConf(options) {
      let { model, closeCallback, redirectParams = null } = options
      this.closeCallback = closeCallback
      this.markerModel = Object.assign({}, model || {})
      this.fields = Object.assign({}, model || {})
      this.registerVueInMap()
      let currentYear = url.getHashParam('year')
      if (!currentYear) {
        currentYear = year.getCurrentYear()
      }
      if (Number(model.size_tonn) > Number(model.power)) {
        this.hasErrorCapacity = true
      }
      let endpoint = mapEndpoints.object('', {
        query: { id: model.tko_object_id || model.id, year: currentYear },
      })
      this.fetchGeoObjectPopupData(endpoint)
      if (redirectParams) {
        this.redirectParams = redirectParams
      }
    },
    close($event) {
      this.closeCallback($event)
    },
  },
}
</script>
